export const spanish = {
  title: {
    welcome: "Bienvenido",
    welcomeNext: "Comencemos con unos simples pasos.",
  },
  signup: {
    name: "Nombre completo",
    last_name: "Apellidos",
    job_position: "Puesto",
    country: "País",
    country_options: {
      MX: "México",
      US: "Estados Unidos",
    },
    email: "Correo electrónico corporativo",
    phone: "Teléfono (opcional)",
    password: "Contraseña",
    repeat_password: "Verificar contraseña",
    company: "Nombre de la empresa",
    website: "Sitio web",
    terms_agree: "Estoy de acuerdo con los terminos y condiciones",
    subscribe: "Quiero suscribirme al NewsLetter",
    register: "Registrarme",
  },
  customPhoneInput: "Ingresa tu teléfono",
};
